<template>
    <div id="top-head"></div>
</template>

<script>
export default {
    name: "top-head"
}
</script>

<style scoped lang = "scss">@import "./top-head";</style>
